const Footer = () => {
  return (
    <>    
    {/* <p> Developed By : Abdelrahman Gad  <bold>  abdelrahmangad95@gmail.com </bold> , Mohammed Emad <bold> omda46330@gmail.com </bold>    </p> */}
    </>
  )
}

export default Footer